const answer =
  'Owner shall use commercially reasonable efforts to provide the following credit in connection with exploitations and uses of the Master(s) where such credits are customarily provided: ' +
  '“<CREDIT_TITLE>”.  No casual or inadvertent failure of Owner to comply with, and no failure of any third party to comply with, the credit provision of this Agreement shall constitute a breach of this Agreement, provided that subsequent to such Owner’s receipt of written notice of any such failure, Owner uses commercially reasonable efforts to prospectively cure any such failure to comply.  Producer hereby grants to Owner the right to use Producer’s approved or provided name, likeness, logos, marks, and biographical information in connection with the Master(s).';

export default (options) => {
  let content = answer;
  let checked = false;

  content = content.replace(
    '<CREDIT_TITLE>',
    options.creditTitle ||
      '<span class="placeholder-text"><u>credit title</u></span>'
  );
  if (options.creditTitle !== '') {
    checked = true;
  }

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/CreditNameLikeness.js